// extracted by mini-css-extract-plugin
module.exports = {"horizontal":"Summary_horizontal__tnnty","summary-menu":"Summary_summary-menu__3L2K2","summary-menu__item":"Summary_summary-menu__item__1GdBJ"};